import React from 'react'
import WelcomePrivacyPolicy from '../components/WelcomePrivacyPolicy/WelcomePrivacyPolicy'
import PrivacyFirst from "../components/PrivacyFirst/PrivacyFirst";

const PrivacyPolicy = () => {
	return (
		<>
			<WelcomePrivacyPolicy />
			<PrivacyFirst />
		</>
	)
}

export default PrivacyPolicy
